'use client';

import { Tooltip } from '@packages/modules/src/Tooltip/Tooltip';
import type { TooltipProps } from '@packages/modules/src/Tooltip/TooltipProps';
import type { ReactNode } from 'react';

export const TooltipWrapper =
  (tooltipContent: TooltipProps['content'], tooltipPositioning: TooltipProps['positioning']) =>
  (children: ReactNode) => (
    <Tooltip
      variant="inline"
      content={tooltipContent || undefined}
      positioning={tooltipPositioning}
    >
      {children}
    </Tooltip>
  );
